var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15263_36607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8613 12.1601C13.4739 12.1601 14.7812 10.8528 14.7812 9.24023C14.7812 7.6276 13.4739 6.32031 11.8613 6.32031C10.2487 6.32031 8.94141 7.6276 8.94141 9.24023C8.94141 10.8528 10.2487 12.1601 11.8613 12.1601Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6097 7.13309V13.309C21.6052 13.7661 21.51 14.2178 21.3297 14.6379C21.1494 15.058 20.8876 15.4381 20.5593 15.7563L18.1121 18.2035L14.3729 21.9427C13.7511 22.5462 12.9248 22.8933 12.0585 22.9147C11.1923 22.9361 10.3498 22.6303 9.69896 22.0582L5.59217 18.4766L3.55454 16.6701C3.1891 16.3459 2.89631 15.9481 2.69539 15.5028C2.49447 15.0575 2.38994 14.5748 2.38867 14.0863V7.35365C2.39196 6.70753 2.57689 6.07535 2.92234 5.52932C3.26779 4.98329 3.75984 4.54541 4.34228 4.26569L10.4447 1.37729C10.8846 1.17399 11.362 1.06434 11.8466 1.0553C12.3312 1.04626 12.8123 1.13802 13.2596 1.32477L19.488 3.96109C20.1165 4.21958 20.6539 4.65925 21.0317 5.22412C21.4095 5.78899 21.6107 6.45351 21.6097 7.13309Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1537 18.1984L14.4146 21.9375C13.7906 22.5531 12.9556 22.9076 12.0794 22.9291C11.2033 22.9506 10.3519 22.6373 9.69858 22.0531L5.5918 18.4715C6.41046 17.5956 7.40356 16.901 8.50709 16.4325C9.61062 15.9639 10.8001 15.7318 11.9988 15.7511C14.2936 15.7196 16.5071 16.5997 18.1537 18.1984V18.1984Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15263_36607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3217,
    height: 24,
    fill: "white",
    transform: "translate(1.33789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminHover);
export default __webpack_public_path__ + "static/media/admin-hover.12e09c62c4cede346dd2073dcb123e79.svg";
export { ForwardRef as ReactComponent };